module.exports = __webpack_public_path__ + "static/media/16UNODC23.05df3e54.jpg";